"use client";

import Link from "next/link";
import { displayMemberPrice, PASS_DISCOUNT_PCT, PASS_HREF } from "@/lib/apex-pass/offer";
import { useApexPass } from "./ApexPassProvider";

/* Shows the Apex Pass price under a digital product's price. Members see
 * their price; everyone else sees what the Pass would save them. Checkout
 * computes the real price on the server; this is display only. */
export function MemberPrice({ usd, className = "" }: { usd: number; className?: string }) {
  const { me } = useApexPass();
  const m = displayMemberPrice(usd);
  if (m == null) return null;
  const fmt = (n: number) => `$${n.toFixed(2).replace(/\.00$/, "")}`;
  if (me?.member) {
    return <p className={`text-sm font-semibold text-amber-300 ${className}`}>Your Pass price: {fmt(m)} at checkout</p>;
  }
  return (
    <p className={`text-sm text-white/65 ${className}`}>
      <Link href={PASS_HREF} className="underline decoration-white/30 underline-offset-4 hover:text-white">
        {fmt(m)} with the Apex Pass
      </Link>{" "}
      <span className="text-white/65">({PASS_DISCOUNT_PCT}% off digital)</span>
    </p>
  );
}
